import { createColumnHelper } from '@tanstack/react-table';
import { PortfolioCentralPaymentPolicyOverviewEntry } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { Body, Link } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { SettlementRuleTiming, SettlementRuleValue } from '../../../../../components';
import { RowActionCell } from './RowActionCell';

const columnHelper = createColumnHelper<PortfolioCentralPaymentPolicyOverviewEntry>();

export const getPaymentPoliciesColumns = ({ onNameClick }: { onNameClick: (id: string) => void }) => [
    columnHelper.accessor('name', {
        header: () => lt('Name'),
        cell: (props) => (
            <Link standalone variant="basic" onClick={() => onNameClick(props.row.id)} data-disable-click-away>
                <Body size="small" wordBreak="break-all" ellipsis maxLines={1} as="span">
                    {props.getValue() ?? UnicodeEntity.Dash}
                </Body>
            </Link>
        ),
    }),
    columnHelper.accessor('propertyCount', {
        header: () => lt('Properties'),
        cell: (props) => <>{props.getValue()}</>,
    }),
    columnHelper.accessor('rateGroupCount', {
        header: () => lt('RateGroupPlural'),
        cell: (props) => <>{props.getValue()}</>,
    }),
    columnHelper.accessor('trigger', {
        header: () => lt('PaymentPolicyTiming'),
        cell: (props) => <SettlementRuleTiming offset={props.row.original.offset} trigger={props.getValue()} />,
    }),
    columnHelper.accessor('value', {
        header: () => lt('Amount'),
        cell: (props) => <SettlementRuleValue {...props.getValue()} />,
    }),
    columnHelper.accessor('action', {
        header: () => lt('Method'),
        cell: (props) => lt(`SettlementRuleAction${props.getValue()}`),
    }),
    columnHelper.accessor('type', {
        header: () => lt('PaymentPolicyMode'),
        cell: (props) => lt(`SettlementRuleType${props.getValue()}`),
    }),
    columnHelper.accessor('key', {
        header: () => lt('Key'),
        cell: (props) => <>{props.getValue()}</>,
    }),
    columnHelper.display({
        id: 'actions',
        meta: { align: 'end' },
        cell: (props) => (
            <RowActionCell paymentPolicyId={props.row.id} rateGroupCount={props.row.original.rateGroupCount} />
        ),
    }),
];
